var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('mt-swipe',{attrs:{"auto":4000}},_vm._l((_vm.img),function(image,index){return _c('mt-swipe-item',{key:index},[_c('img',{attrs:{"src":image,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }